const ToastMessages = {
  facePicture: [
    {
      text: "Sad to see you would close me, I'll stay here anyway.",
      delay: 5000,
    },
  ],

  portfolioProject: [
    {
      text: "Hope you are getting fun while trying to delete my projects... But I'll keep it, sorry.",
      delay: 5000,
    },
    {
      text: "It took me time to make it :( ... So I'll keep it, sorry.",
      delay: 4000,
    },
  ],

  portfolioDesc: [
    {
      text: "Fun fact: I've never used macOS. Wait, how much time passed since I wrote this?",
      delay: 5000,
    },
    {
      text: "I like to write, have never published anything though.",
      delay: 5000,
    },
    {
      text: `'The strength of JavaScript is that you can do anything. The weakness is that you will.'
      Reg Braithwaite`,
      delay: 8500,
    },
  ],

  portfolioDemo: [
    {
      text: "I tried my best.",
      delay: 3000,
    },
    {
      text: "CSS is interesting.",
      delay: 3000,
    },
    {
      text: "What interactions would you add?",
      delay: 4000,
    },
    {
      text: "Okay... stop closing me :(",
      delay: 4000,
    },
    {
      text: "So much to learn, love it :)",
      delay: 4000,
    },
  ],
};

export default ToastMessages;
